/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useAccountId } from '../../ContextProviders/CurrentAccount'
import { AccountType, type CareNetworkCommunication, NoteType, type postError } from '../../core/types'
import { FormatDateValue } from '../../core/Utilities'
import { useAuth } from '../../hooks/use-auth'
import { sendPost, sendGet } from '../../hooks/use-fetch'
import { CommunicationDetail } from '../../Pages/CareNetworkManagement/CareNetworkDetail/CommunicationDetail'

export function AddReminderModal (props: { childId: number, show: boolean, setShow: (newVal: boolean) => void }): JSX.Element {
  const [reminderUsers, setReminderUsers] = useState<Array<{ id: number, name: string }>>([])
  const { user } = useAuth()
  const initialRecord: CareNetworkCommunication = {
    userID: user?.id ?? 0,
    addressedWhatMatteredMost: null,
    caregiverID: null,
    contactMethodID: null,
    enteredOn: new Date(),
    id: 0,
    type: NoteType.Reminder,
    childID: props.childId,
    needMet: null,
    note: '',
    reasonNotMet: '',
    reminderDate: null,
    referralID: null,
    enrollmentID: null
  }
  const [reminderRecord, setReminderRecord] = useState<CareNetworkCommunication>(initialRecord)

  const emptyRecord: CareNetworkCommunication = {
    type: NoteType.Reminder
  } as CareNetworkCommunication
  const account = useAccountId()
  const handleReminderClose = (): void => {
    props.setShow(false)
  }

  const [requestIsLoading, setRequestIsLoading] = useState(false)
  const handleReminderAccept = async (com: CareNetworkCommunication): Promise<void> => {
    if (!requestIsLoading) {
      setRequestIsLoading(true)
      const result = await sendPost('/Communication/CreateCommunication', com)
      const rsp: { success: boolean, errors: postError[] } = result.response
      if (rsp.success) {
        props.setShow(false)
        const userindex = reminderUsers.findIndex(x => x.id === com.userID)
        toast.success(`Communication record was updated. A reminder will be sent on ${FormatDateValue(com.reminderDate ?? new Date())} to ${reminderUsers[userindex].name}`)
      }
      setRequestIsLoading(false)
    }
  }
  useEffect(() => {
    const setReminder = async (): Promise<void> => {
      switch (account?.type) {
        case AccountType.ISD: {
          const { response } = await sendGet(`/ISDStaff/GetStaffList?isdID=${account?.id}`, {})
          if (response !== null) {
            setReminderUsers(response)
          }
        }
          break
        case AccountType.SERVICE_PROVIDER: {
          const { response } = await sendGet(`/ServiceProviderSettings/GetProviderStaff?spID=${account?.id ?? 0}`, {})
          if (response !== null) {
            const users: Array<{ id: number, name: string }> = response.map((a: { id: number, firstName: string, lastName: string }) => {
              return { id: a.id, name: `${a.firstName} ${a.lastName}` }
            })
            setReminderUsers(users)
          }
        }
          break
        case AccountType.INTAKE_USER: {
          const { response } = await sendGet(`/ServiceProviderSettings/GetIntakeUserStaff?spID=${account?.id ?? 0}`, {})
          if (response !== null) {
            const users: Array<{ id: number, name: string }> = response.map((a: { id: number, firstName: string, lastName: string }) => {
              return { id: a.id, name: `${a.firstName} ${a.lastName}` }
            })
            setReminderUsers(users)
          }
        }
          break
      }
      if (props.show) { setReminderRecord(initialRecord) }
    }
    void setReminder()
  }, [account, props.show])

  return <>

    <CommunicationDetail
      open={props.show}
      onClose={handleReminderClose}
      onSubmit={handleReminderAccept}
      isNew={true}
      selectedCommunication={reminderRecord ?? emptyRecord}
      userOptions={reminderUsers}
    />

  </>
}
